import PropTypes from "prop-types";
import { Horizontal } from "./styles";

export const Aligned = ({ isHorizontalComponent, children }) => {
  const Component = isHorizontalComponent ? Horizontal : "div";
  return (
    <Component
      className={!isHorizontalComponent ? "p-16 border border-neutral-20 rounded-4 bg-neutral-10" : undefined}
    >
      {children}
    </Component>
  );
};

Aligned.propTypes = {
  isHorizontalComponent: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
